import React, { useState, useRef, useCallback } from "react"

import useTracking from "hooks/useTracking"

import DropDownArrow from "icons/drop-down-arrow"
import { Container, Source, TextAndCode, Code, ViewButton, SeeMoreOptions } from "./styles"

const Sources = ({ sources = [], product }) => {
  const { id, title } = product

  const [toggleAll, setToggleAll] = useState(false)

  const { trackView, trackClick } = useTracking()
  const viewRef = useRef(null)
  const clickRef = useRef(null)

  const source = sources.length ? sources[0].source : ""
  const trackingId = `Product Review Component | ${title} | ${source}`
  const trackingProps = {
    label: trackingId,
    category: "Commerce Engagement",
    product: title,
    product_id: id,
    quickView: false,
    source,
  }

  trackView(viewRef, trackingId, trackingProps)
  trackClick(clickRef, trackingId, trackingProps)

  const formatPrice = (price) => {
    if (typeof price === "number") {
      return ` | $${price}`
    }

    if (typeof price === "string" && /^\$\d+/.test(price?.trim())) {
      return ` | ${price}`
    }

    return ""
  }

  const isPromotionValid = useCallback((promotion) => {
    const actualDate = new Date().toISOString()
    return (
      promotion?.active &&
      (promotion?.startsAt || promotion?.endsAt
        ? promotion?.startsAt < actualDate || promotion?.endsAt > actualDate
        : true)
    )
  }, [])

  return (
    <Container ref={viewRef}>
      {sources.slice(0, toggleAll ? sources.length : 1).map((src, i) => {
        const price = formatPrice(src.price)
        const { promotion } = src
        const hasPromotion = isPromotionValid(promotion)
        const url = hasPromotion && promotion.url ? promotion.url : src.url

        return (
          <Source key={src.id} hasPromotion={hasPromotion}>
            {hasPromotion && (
              <TextAndCode>
                {promotion?.text}: <Code>{promotion?.code}</Code>
              </TextAndCode>
            )}
            <ViewButton ref={clickRef} href={url} target="_blank" rel="sponsored">
              View on {src.source}
              {price}
            </ViewButton>
            {sources.length > 1 && (i === sources.length - 1 || !toggleAll) && (
              <SeeMoreOptions onClick={() => setToggleAll(!toggleAll)}>
                <span>{!toggleAll ? "See more options" : "See less options"}</span>
                <DropDownArrow style={{ rotate: toggleAll ? "180deg" : "0deg" }} />
              </SeeMoreOptions>
            )}
          </Source>
        )
      })}
    </Container>
  )
}

export default Sources
